import { Directive, ElementRef, Renderer2, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[ncPulsating]'
})
export class PulsatingDirective implements OnInit, OnDestroy, OnChanges {
  /** 动画时长，单位ms */
  @Input() ncDuration: number = 1500;
  /** 默认浅蓝色光晕 */
  @Input() ncColor: string = '#0096ff';
  /** 最大光晕宽度 */
  @Input() ncSize: string = '8px';
  /** 停止动画时间，ms，0表示不停止 */
  @Input() ncStopTime: number = 0;
  /** 是否启用脉冲动画 */
  private _enbaled: boolean = true;
  @Input()
  set ncEnabled(val: boolean | string) {
    this._enbaled = val !== null && val !== undefined && val !== false && val !== 'false';
  }
  get ncEnabled(): boolean {
    return this._enbaled;
  }

  /** 双向绑定输出事件 */
  @Output() ncEnabledChange = new EventEmitter<boolean>();

  private pulsatingContainer!: HTMLElement;
  private readonly animationName: string;
  private shouldStop = false;
  private stopTimer: any;
  private styleElement!: HTMLElement;
  private isInitialized = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    // 为每个实例生成唯一的动画名称
    this.animationName = `ncPulse_${Math.random().toString(36).substring(2, 11)}`;
  }

  ngOnInit() {
    this.createPulsatingContainer();
    this.isInitialized = true;
    if (this.ncEnabled) {
      this.startAnimation();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isInitialized && changes['ncEnabled']) {
      if (this.ncEnabled) {
        this.startAnimation();
      } else {
        this.stopAnimation();
      }
    }
  }

  ngOnDestroy() {
    if (this.stopTimer) {
      clearTimeout(this.stopTimer);
    }
  }

  private createPulsatingContainer() {
    this.pulsatingContainer = this.renderer.createElement('div');
    this.renderer.addClass(this.pulsatingContainer, 'nc-pulsating-container');
    // 设置基础样式
    this.renderer.setStyle(this.pulsatingContainer, 'position', 'absolute');
    this.renderer.setStyle(this.pulsatingContainer, 'inset', '0');
    this.renderer.setStyle(this.pulsatingContainer, 'borderRadius', 'inherit');
    this.renderer.setStyle(this.pulsatingContainer, 'pointerEvents', 'none');
    this.renderer.setStyle(this.pulsatingContainer, 'zIndex', '0');

    const elementPosition = getComputedStyle(this.el.nativeElement).position;
    if (!elementPosition || elementPosition === 'static') {
      this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
    }

    // 添加关键帧动画样式
    this.styleElement = this.renderer.createElement('style');
    const keyframes = `
      @keyframes ${this.animationName} {
        0% {
          box-shadow: 0 0 0 0 ${this.ncColor};
        }
        50% {
          box-shadow: 0 0 0 ${this.ncSize} ${this.ncColor};
          opacity: 0.5;
        }
        100% {
          box-shadow: 0 0 0 0 ${this.ncColor};
        }
      }
    `;
    this.renderer.appendChild(this.styleElement, this.renderer.createText(keyframes));
    this.renderer.appendChild(this.el.nativeElement, this.styleElement);

    // 将容器添加到宿主元素中
    this.renderer.appendChild(this.el.nativeElement, this.pulsatingContainer);

    // 监听动画迭代事件，用于平滑停止
    this.renderer.listen(this.pulsatingContainer, 'animationiteration', () => {
      if (this.shouldStop) {
        this.renderer.setStyle(this.pulsatingContainer, 'animation', 'none');
        this.shouldStop = false;
      }
    });
  }

  private startAnimation() {
    if (!this.pulsatingContainer) return;

    this.shouldStop = false;
    this.renderer.setStyle(this.pulsatingContainer, 'animation',
      `${this.animationName} ${this.ncDuration}ms ease-in-out infinite`);

    // 如果设置了停止时间，则在指定时间后标记需要停止
    if (this.ncStopTime > 0) {
      this.stopTimer = setTimeout(() => {
        this.stopAnimation();
        // 当因为 ncStopTime 停止动画时，更新 ncEnabled 值并发出事件
        this.ncEnabled = false;
        this.ncEnabledChange.emit(false);
      }, this.ncStopTime);
    }
  }

  private stopAnimation() {
    if (!this.pulsatingContainer) return;

    if (this.stopTimer) {
      clearTimeout(this.stopTimer);
      this.stopTimer = null;
    }

    this.shouldStop = true;
  }
}